var React = require('react');

function Car (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M43 32.332v2.043a3.125 3.125 0 1 1-6.25 0v-2.043h-30v2.043a3.125 3.125 0 1 1-6.25 0V21.659a9.996 9.996 0 0 1 5-8.662V10c0-5.523 4.477-10 10-10H28c5.523 0 10 4.477 10 10v2.997a9.996 9.996 0 0 1 5 8.662v10.673zM15.5 3.906a6.25 6.25 0 0 0-6.25 6.25v2.795h25v-2.795A6.25 6.25 0 0 0 28 3.906H15.5zM8 21.996c1.38 0 2.5-1.158 2.5-2.585S9.38 16.827 8 16.827s-2.5 1.157-2.5 2.584 1.12 2.584 2.5 2.584zm27.5 0c1.38 0 2.5-1.158 2.5-2.585s-1.12-2.584-2.5-2.584-2.5 1.157-2.5 2.584 1.12 2.584 2.5 2.584zM7.375 24.578c-1.036 0-1.875.84-1.875 1.875v.127c0 1.035.84 1.875 1.875 1.875h28.75c1.036 0 1.875-.84 1.875-1.875v-.127c0-1.035-.84-1.875-1.875-1.875H7.375z","fill":"currentColor","fillRule":"nonzero","fillOpacity":"1"}));
}

Car.defaultProps = {"width":"43","height":"38"};

module.exports = Car;

Car.default = Car;
